import {useAdjustCreativeQuery} from './use-adjust-creative-query';
import {useSiteMetadata} from './use-site-metadata';

/**
 * ダウンロード URL 一式を取得する
 *
 * @param {Object} params - params
 * @param {string} params.pathname - 設置対象ページの location.pathname
 * @returns {{appStoreUrl: string, googlePlayUrl: string, unifiedStoreUrl: string}}
 */
export const useDownloadLink = ({pathname}: {pathname: string}) => {
  const {
    downloadUrl,
    downloadUrlAppStoreParam,
    downloadUrlGooglePlayParam,
    downloadUrlHelloVandle,
  } = useSiteMetadata();
  const baseUrl = pathname.match(/^(\/hello|\/hello\/|\/hello\/.*)$/)
    ? downloadUrlHelloVandle
    : downloadUrl;
  const creativeQuery = useAdjustCreativeQuery({pathname});
  return {
    /**
     * App Store へのリンク
     */
    appStoreUrl: `${baseUrl}?${creativeQuery}&${downloadUrlAppStoreParam}`,
    /**
     * Google Play へのリンク
     */
    googlePlayUrl: `${baseUrl}?${creativeQuery}&${downloadUrlGooglePlayParam}`,
    /**
     * 統合 (自動振り分け) リンク
     */
    unifiedStoreUrl: `${baseUrl}?${creativeQuery}`,
  };
};
